
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDimensions, setFrame, setPlaying } from "../../redux/slices/canvas";
import { RootState } from "../../redux/store";
import RemotionPlayer from "../../remotion/RemotionPlayer";
import { ProjectState } from "../../shared";
import { roundEven } from "../preview/Preview";
import { resizeLayers } from "./helpers/project";

type Props = {
  project: ProjectState
}

function Canvas({ project: _project }: Props) {
  const dispatch = useDispatch();
  const lastSelectedLayer = useSelector((state: RootState) => state.project.lastSelectedLayer);
  const playing = useSelector((state: RootState) => state.canvas.playing);

  const project = {
    ..._project,
    dimensions: {
      ..._project.dimensions
    },
    layers: [
      ..._project.layers
    ]
  };
  const height = roundEven(window.innerHeight * 0.75);
  const width = roundEven(height * project.dimensions.width / project.dimensions.height);

  useEffect(() => {
    dispatch(setDimensions({ width, height }));
  }, [width, height, dispatch]);

  // resize project & layer dimensions to fit in canvas 
  project.layers = resizeLayers(project, width, height);
  project.dimensions.width = width;
  project.dimensions.height = height;
  
  let seekToFrame: number | undefined = undefined;
  if (lastSelectedLayer !== undefined) {
    const layer = project.layers[lastSelectedLayer];
    seekToFrame = layer?.startFrame;
  }

  return (
    <div>
      <RemotionPlayer 
        project={project} 
        seekToFrame={seekToFrame}
        shouldPlay={playing}
        onFrameUpdate={(frame) => dispatch(setFrame(frame))}
        onPlay={() => dispatch(setPlaying(true))}
        onPause={() => dispatch(setPlaying(false))}
      />
    </div>
  );
}

export default Canvas;